import React from 'react';
import Title from 'lib/src/components/typography/Title';
import Description from 'lib/src/components/typography/Description';
import ChallengeTagsTable from '@pages/challengeTags/ChallengeTagsTable';
import { useParams } from 'react-router';
import DeleteTagModal from '@pages/challengeTags/DeleteTagModal';
import EditTagModal from '@pages/challengeTags/EditTagModal';
import { tagTypes } from 'lib/src/shared/enums/tagTypes';
import CreateTagModal from '@pages/challengeTags/CreateTagModal';
import CreateHeader from '@components/layout/createHeader/CreateHeader';
import LinkButton from '@components/button/LinkButton';
import { getTagRouteEndpoint } from '@pages/challengeTags/utils';

const ChallengeTechnology: React.FC = () => {
    const { id, action } = useParams<ParamTypes>();

    return (
        <>
            <CreateHeader>
                <Title>Challenge Technology</Title>
                <LinkButton
                    color="green"
                    icon="plus"
                    href={`/${getTagRouteEndpoint(tagTypes.business)}/create`}
                >
                    Create
                </LinkButton>
            </CreateHeader>
            <Description>
                Here is the list of challenge tags currently in the system. To share a tag with a
                user in a URL, replace all spaces with dashes i.e. 'challenge name' with
                'challenge-name'.
            </Description>
            <ChallengeTagsTable type={tagTypes.business} />
            {action === 'delete' && <DeleteTagModal id={+id} />}
            {action === 'edit' && <EditTagModal id={+id} />}
            {action === 'create' && <CreateTagModal type={tagTypes.business} />}
        </>
    );
};
interface ParamTypes {
    id: string;
    action: string;
}
export default ChallengeTechnology;
